export const SALVAR_DADOS_USUARIO = 'SALVAR_DADOS_USUARIO';
export const SALVAR_LISTA_PRODUTOS = 'SALVAR_LISTA_PRODUTOS';
export const SALVAR_VALOR_RECARGA = 'SALVAR_VALOR_RECARGA';
export const SALVAR_TIPO_VEICULO = 'SALVAR_TIPO_VEICULO';
export const SALVAR_DESCONTO = 'SALVAR_DESCONTO';
export const ONDE_USAR = 'ONDE_USAR';
export const RECEBER_ADESIVO = 'RECEBER_ADESIVO';
export const ONDE_RECEBER = 'ONDE_RECEBER';
export const TIPO_PAGAMENTO = 'TIPO_PAGAMENTO';
export const RESET_TIPO_PAGAMENTO = 'RESET_TIPO_PAGAMENTO';
export const TOTAL_PRODUTOS = 'TOTAL_PRODUTOS';
export const SAVE_CAPTCHA = 'SAVE_CAPTCHA';
export const SALVAR_PEDIDO = 'SALVAR_PEDIDO';
export const SALVAR_CODIGO_PROMOCIONAL = 'SALVAR_CODIGO_PROMOCIONAL';
export const SALVAR_DADOS_VEICULO = 'SALVAR_DADOS_VEICULO';
export const FEATURE_FLAG_TAG_ATIVA = 'FEATURE_FLAG_TAG_ATIVA';

/**
 * Salva as informações de pagamento
 * */
export function tipoPagamento(infoPagamento) {
  return {
    type: TIPO_PAGAMENTO,
    tipoPagamento: infoPagamento,
  };
}

/**
 * Reseta as informações de pagamento
 * */
export function resetTipoPagamento() {
  return { type: RESET_TIPO_PAGAMENTO };
}

/**
 * Salva as informações de pagamento
 * */
export function totalProdutos(infoTotal) {
  return {
    type: TOTAL_PRODUTOS,
    infoTotal,
  };
}

/**
 * Salva os locais de uso
 * */
export function salvarOndeUsar(ondeUsar) {
  return {
    type: ONDE_USAR,
    ondeUsar,
  };
}

/**
 * Salva os locais de uso
 * */
export function salvarDesconto(cupomDesconto) {
  return {
    type: SALVAR_DESCONTO,
    cupomDesconto,
  };
}
/**
 * Salva se o usuario quer ou nao receber adesivo em casa
 * */
export function salvarReceberAdesivo(receberAdesivo) {
  return {
    type: RECEBER_ADESIVO,
    receberAdesivo,
  };
}

/**
 * Salva o endereço do usuário
 * */
export function ondeReceber(dadosEndereco) {
  return {
    type: ONDE_RECEBER,
    dadosEndereco,
  };
}

/**
 * Salva os dados do Veículo
 * */
export function salvarTipoVeiculo(tipoVeiculo) {
  return {
    type: SALVAR_TIPO_VEICULO,
    tipoVeiculo,
  };
}

/**
 * Salva os produtos selecionados
 * */
export function salvarListaProdutos(listaDeProdutos) {
  return {
    type: SALVAR_LISTA_PRODUTOS,
    listaDeProdutos,
  };
}

/**
 * Salva o valor de recarga
 * */
export function salvaValorRecarga(valorRecarga) {
  return {
    type: SALVAR_VALOR_RECARGA,
    valorRecarga,
  };
}

/**
 * Salva o codigo promocional
 * */
export function salvarCodigoPromocional(codigoPromocional) {
  return {
    type: SALVAR_CODIGO_PROMOCIONAL,
    codigoPromocional,
  };
}

export function salvarFeatureFlag(featureFlag) {
  return {
    type: FEATURE_FLAG_TAG_ATIVA,
    featureFlag
  }
}

export function salvarDadosVeiculo(dadosVeiculo) {
  return {
    type: SALVAR_DADOS_VEICULO,
    dadosVeiculo
  }
}

// Types

/**
 * Salva os dados do Usuário
 * */
export function salvarDadosUsuario(dadosUsuario) {
  return {
    type: SALVAR_DADOS_USUARIO,
    dadosUsuario,
  };
}

export function saveCaptcha(captchaResponse) {
  return {
    type: SAVE_CAPTCHA,
    captchaResponse,
  };
}

export function salvarPedido(pedido) {
  return {
    type: SALVAR_PEDIDO,
    pedido,
  };
}
